import c from './AddSockets.module.css'
import { useParams } from 'react-router-dom'

import {
    instantiateRtSocketsToExistingRtProcess
} from './../../../utils/api'

export const AddSockets = ({
    dtProcess,
    rtProcess,
    output,
    onRtSocketsAdd
}) => {
    const { id: rtTaskId } = useParams();

    const handleClick = () => {
        instantiateRtSocketsToExistingRtProcess
            (
                rtTaskId,
                rtProcess.id,
                output ? "output" : "input"
            ).then(res => {
                const newRtSockets = res.rt_sockets
                onRtSocketsAdd(newRtSockets)
            }).catch(err => {
                alert("Error adding sockets to process")
                console.error(err)
            })
    }

    return (
        <div className={c['ctr']} onClick={handleClick}>
            Add Missing Sockets
        </div>

    )
}
